import React from 'react';
import { IAnswer } from '../model/Interfaces';

export interface IQuizAnswerProps{
    Answer: IAnswer,
    CssClass?: string,
    key: string,
    onSelect(Answer:IAnswer): void
}

function QuizAnswer(props: IQuizAnswerProps): React.ReactElement{
    const raiseSelect = ():void =>{
        props.onSelect(props.Answer);
    }

    return (
        <button onClick={raiseSelect} className={props.CssClass} >
            <span>{props.Answer.key})</span>
            <span>{props.Answer.answer}</span>
        </button>
    );
}

export default QuizAnswer;
